export default __webpack_public_path__ + "static/media/graph-box.42f6259d.png";